import { render, staticRenderFns } from "./DealIssue.vue?vue&type=template&id=3bc7d053&scoped=true&"
import script from "./DealIssue.vue?vue&type=script&lang=js&"
export * from "./DealIssue.vue?vue&type=script&lang=js&"
import style0 from "./DealIssue.vue?vue&type=style&index=0&id=3bc7d053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc7d053",
  null
  
)

export default component.exports